

export class AutoCompleteModel {
      url: string;
      searchKey: string;
      minSearchLength = 4;
      placeholder = '';
      params?: any;
}


// Example

// createAutoComplete() {
//       this.autoBasic = new AutoCompleteModel();
//       this.autoBasic.url = Constants.IN_AUTO_SEARCH_SUGGEST_URL;
//       this.autoBasic.searchKey = 'search';
//       this.autoBasic.placeholder = 'Search';
//     }
